import { SpinResponse } from '@cgs/data-access';
import { GameStateMachine } from '../state_machine/game-state-machine';

export const GAME_STATE_MACHINE_PROVIDER_TOKEN = Symbol('GAME_STATE_MACHINE_PROVIDER_TOKEN');

export interface IGameStateMachineProvider {
  gameStateMachine: GameStateMachine<SpinResponse>;
  deinitialize(): void;
}
